import { FETCH_PET,FETCH_PET_DATA ,FETCH_PET_MODAL ,FETCH_PET_KIND_ID} from "./ActionTypes";
 
export const fetchPetId = (id) => { 
  return {
    
    type: FETCH_PET,
    payload: id,
  };
};
export const fetchPetUserId = (id) => { 
  return {
    
    type: "FETCH_PETUSERID",
    pet_user_id: id,
  };
};

export const fetchPetKindId = (id) => { 
  return {
    
    type: FETCH_PET_KIND_ID,
    petKindId: id,
  };
};
 
 
export const fetchPetAllData= (obj) => { 
  return {
    
    type: FETCH_PET_DATA,
    petData: obj,
  };
};
export const fetchPetModal =  (modal) => { 
  return {
    
    type: FETCH_PET_MODAL,
    petModal: modal,
  };
};
